import { object, number, date } from 'yup';

export const customerAssignmentsInsertRangeValidation = object().shape({
  siteId: number().required('שדה חובה'),
  voucherExpiryDate: date().nullable(),
  sBSubscriptionVoucherDurationInMonths: number()
    .nullable()
    .positive('משך השובר חייב להיות ריק או גדול מאפס'),
  upgradeToSmartLockerVoucherDurationInMonths: number()
    .nullable()
    .positive('משך השובר חייב להיות ריק או גדול מאפס'),
});
